<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      event: null,
      pageSettings: null,
      tcId: null,
      consentInfo: null,
      isTCIDValid: false,
      isKVKKApproved: false
    };
  },
  created() {}
};
</script>


<style lang="scss">
#app {
}
.footer {
  position: absolute;
  bottom: 0;
  height: 56px;
}
</style>
